export const educationTitle = "Education";

export const educationData = [
  {
    key: 3,
    importance: 1,
    date: "January 2021 - July 2021",
    title: "Full Stack Blockchain Developer",
    establishment: { name: "Alyra School", url: "https://alyra.fr/", location: "Paris, France" },
    details: [],
    info: "Certification covering the full blockchain stack: Solidity smart contracts, Web3 integration, React front-ends, and Node.js back-end services. Included building and deploying dApps end-to-end.",
    skills: [
      "Solidity",
      "Web3",
      "Hardhat",
      "HTML",
      "CSS",
      "JavaScript",
      "React.js",
      "Node.js",
      "Express",
      "REST API",
      "PostgreSQL",
      "Git",
    ],
    image: "",
    links: [
      {
        name: "certificate",
        url: "https://certificate.bcdiploma.com/check/6EFD04E16859B0BAF0752BD2D5684CC615B806DF693940B340B2E9320121E592YXdvSkJCclBnd1VIekRDMXVzQ2R0NHF0UTM2ek1ZUk5yTHU1bUg5RUZOR1h1TG5Y",
      },
    ],
  },
  {
    key: 2,
    importance: 2,
    date: "September 2013 - June 2016",
    title: "MSc Information Technology Engineer",
    establishment: {
      name: "National Superior School of Mines",
      url: "https://www.imt-mines-albi.fr/",
      location: "Albi, France",
    },
    details: [],
    info: "Three-year engineering degree from one of France's top engineering school, covering IT systems, architecture, networks, and software development.",
    skills: ["Industrial", "Logistic", "IT Systems", "ERP", "Robotics"],
    image: "",
    links: [
      {
        name: "diploma",
        url: "https://www.cvtrust.com/SmartDiploma/Default.aspx?TOGUEvPmbwt7fTZFKrcvhOQlOWx5jYs9Iewh0a61InQIX0rkixRKd88yJDHejiuQ#/",
      },
    ],
  },
  {
    key: 1,
    importance: 3,
    date: "September 2011 - June 2013",
    title: "Intensive course of Mathematics & Physics",
    establishment: {
      name: "Michelet Hightschool",
      url: "http://www.cite-scolaire-michelet-vanves.ac-versailles.fr/",
      location: "Vanves, France",
    },
    details: [],
    info: "Selective two-year program in advanced mathematics and physics: the standard French pathway before engineering schools. High-pressure, high-competition. Built the capacity for deep concentration and rigorous thinking that carries into every technical challenge since.",
    skills: ["Algebra", "Geometry", "Statisitcs"],
    image: "",
    links: [{ name: "", url: "" }],
  },
];
